import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();
const API_URL = import.meta.env.VITE_API_URL || "https://api.endoac.ro";

export const AuthProvider = ({ children }) => {
  const readStorageJson = (key) => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      console.warn(`Valoare invalidă în localStorage pentru ${key}, folosesc fallback.`, error);
      return null;
    }
  };

  const normalizeRole = (role) => {
    const map = {
      admin: "admin",
      doctor: "doctor",
      medic: "doctor",
      assistant: "assistant",
      asistent: "assistant",
      nurse: "assistant",
      patient: "patient",
      pacient: "patient",
    };
    return map[role?.toLowerCase?.()] || role || null;
  };

  const normalizeUser = (user) => {
    if (!user) return null;
    return { ...user, role: normalizeRole(user.role) };
  };

  const [currentUser, setCurrentUser] = useState(() => {
    const stored = readStorageJson("user");
    return normalizeUser(stored);
  });
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  
  // 🔁 Persistă datele la schimbare
  useEffect(() => {
    if (currentUser) localStorage.setItem("user", JSON.stringify(currentUser));
    else localStorage.removeItem("user");
  }, [currentUser]);

  useEffect(() => {
    if (token) localStorage.setItem("token", token);
    else localStorage.removeItem("token");
  }, [token]);

  // 🔐 Login real
  const login = async (email, password) => {
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Autentificare eșuată");

      const normalized = normalizeUser(data.data.user);
      setToken(data.data.token);
      setCurrentUser(normalized);
      return normalized;
    } catch (err) {
      console.error("Login error:", err.message);
      throw err;
    }
  };

  // 🧾 Înregistrare nouă (opțional)
  const register = async (name, email, password, role = "doctor") => {
    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password, role }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Înregistrare eșuată");
      return data.message;
    } catch (err) {
      console.error("Register error:", err.message);
      throw err;
    }
  };

  // 🚪 Logout complet
  const logout = () => {
    setCurrentUser(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider value={{ currentUser, token, login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
